import {
  Box,
  Button,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import { useQueryClient } from "@tanstack/react-query";
import { useFormik } from "formik";
import { inputCommonStyle } from "../../../util/admin/cssCommonStyle";
import MaterialModal from "../../app/material-modal";
import { useUpdateSeat } from "../../../tanstackQuery/queries/superAdmin/invoice";
import { toast } from "sonner";
import { useParams } from "react-router-dom";

const ExtendSeatModal = ({ open, handleClose, tableData }) => {

  const { keycloak } = useKeycloak();
  const { orgID } = useParams();
  const client = useQueryClient();

  const {
    mutateAsync: extendSeat,
    isPending,
    isSuccess,
  } =  useUpdateSeat(
    { accessToken: keycloak?.token },
    {
      onSuccess: () => {
        client.invalidateQueries({ queryKey: ["orgUserList"]});
        handleClose();
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      days: 0,
    },
    onSubmit: (values) => {
      handleExtendSeat(values);
    },
  });

  const handleExtendSeat = async (values) => {
    
    const payload = {
      days: values.days,
      orgID,
      userID:tableData?.userID,
      seatID:tableData?.seatID
    };

    try {
      await extendSeat(payload);
      if (isSuccess) {
        toast.success("Seat duration successfully extended!");
        formik.resetForm();
        handleClose();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to extend seat.");
    }
  };

  return (
    <MaterialModal
      open={open}
      handleDialogClose={handleClose}
      title="Extend Seat"
      styleOverrides={{
        container: {
          "& .MuiDialog-paper": {
            width: "100%",
            maxWidth: "500px",
            ".MuiDialogContent-root": {
              overflow: "auto",
            },
          },
        },
      }}
    >
      <form onSubmit={formik.handleSubmit}>
        <Stack direction="column" gap={3}>
          {/* Dropdown */}
          <Stack direction="row" gap={3}>
            <Typography variant="body1" sx={{ flexBasis: "30%" }}>
              Number of days *
            </Typography>
            <TextField
              name="days"
              id="outlined-basic"
              type="number"
              variant="outlined"
              size="small"
              value={formik.values.days}
              onChange={formik.handleChange}
              //   fullWidth
              sx={inputCommonStyle}
              error={
                formik.submitCount > 0 && Boolean(formik.errors.days)
              }
              helperText={formik.submitCount > 0 && formik.errors.days}
            />
          </Stack>

          {/* Actions */}
          <Box display="flex" justifyContent="flex-end" gap={1}>
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              onClick={handleExtendSeat}
                disabled={isPending}
                endIcon={isPending ? <CircularProgress size={16} /> : null}
            >
              Save
            </Button>
          </Box>
        </Stack>
      </form>
    </MaterialModal>
  );
};

export default ExtendSeatModal;
